import { render } from "./bot-api-key.vue?vue&type=template&id=15ea2af5"
import script from "./bot-api-key.vue?vue&type=script&lang=js"
export * from "./bot-api-key.vue?vue&type=script&lang=js"

import "./bot-api-key.vue?vue&type=style&index=0&id=15ea2af5&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__